"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".thx-text[_ngcontent-%COMP%]{font-size:18px;font-weight:700;font-family:\"Open Sans\",Arial,Helvetica,sans-serif}.thx-term[_ngcontent-%COMP%]{font-size:16px;font-style:italic}.mat-thx-exit[_ngcontent-%COMP%]{background-color:#ff6350;color:#fff;box-shadow:none!important}.mat-thx-over[_ngcontent-%COMP%]{box-shadow:none!important}.mat-thx-over[_ngcontent-%COMP%]:hover{box-shadow:none!important;color:#ff6350}"];
exports.styles = styles;
